import { ReviewPage } from "@/pages/admin/Payments";

export default function TopUps() {
  return <ReviewPage base="/admin/topups" title="Wallet top-ups" kind="topup" approveMsg="Money added to wallet" />;
}
